/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Faq_EyebrowInputs */

const en_directory_faq_eyebrow = /** @type {(inputs: Directory_Faq_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI help`)
};

const zh_directory_faq_eyebrow = /** @type {(inputs: Directory_Faq_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 帮助`)
};

/**
* | output |
* | --- |
* | "Seek AI help" |
*
* @param {Directory_Faq_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_faq_eyebrow = /** @type {((inputs?: Directory_Faq_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Faq_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_faq_eyebrow(inputs)
	return zh_directory_faq_eyebrow(inputs)
});
export { directory_faq_eyebrow as "directory.faq.eyebrow" }